$(document).ready(function () {
    console.log("Working======");
    $(".bundle-products-section .size-type-selector select").change(function () {
      console.log("Select typ===");
      console.log($(this).val());
      $(this).parents(".bundle-card").find(".size-selector select").removeClass("active");
      $(this).parents(".bundle-card").find(`.size-selector select#option-${$(this).val()}`).addClass("active");
      //  $(".bundle-products-section .size-selector select").removeClass("active");
      //  $(`.bundle-products-section .size-selector select#option-${$(this).val()}`).addClass("active");
      
    });
    $(".bundle-products-section .size-type-wrapper .size-selector select").change(function () {
      console.log("Select size===");
      console.log($(this).val());
      console.log($(this).find("option:selected").data("available"));
      
      if (!$(this).find("option:selected").data("available")) {
        $(this).parents(".bundle-card").prepend("<span class='sold-out'>Sold Out</span>")
      }
      else{
        $(this).parents(".bundle-card").find(".sold-out").remove();
      }
    //   if (!$(".bundle-products-section .bundle-card .sold-out").length) {
    //    $(".bundle-products-section button.atc-btn").removeClass("disable")
    //  }
    //  else{
    //   $(".bundle-products-section button.atc-btn").addClass("disable")
    //  }
      
    });
    
   $(".bundle-products-section .atc-bundle-section .atc-btn").click(function () {
    $(".main-btn .button-text").attr("style", "display: none");
    $(".main-btn .loading").attr("style", "display: block");
    if ($("body").hasClass("saree-shaper")) {
      addSareeShaper();
    }
    else{
 
    let qty=$("input.t4s-quantity-input").val()
    let bundle_cart=[];
    let selected_size=$("input[name='globo-option-0']:checked").val();
     let option1=   $(".size-optionA .t4s-swatch__list .t4s-swatch__item.is--selected").text()

    let selected_main_pdt=$("form select[name='id'] option:checked").val()
    console.log("selected_size===",selected_size);
    console.log("option1===",option1);
     console.log("selected_main_pdt===",selected_main_pdt);
      if (selected_size && $("body").hasClass("saree-shaper")) {
    
      }
     let total_bundles= $(".bundle-products-section .bundle-card").length
     for (let i = 1; i < total_bundles; i++) {
      let variant_id=$(".bundle-products-section .bundle-card").eq(i).find("select").val()
      console.log("Variant===",variant_id);
       bundle_cart.push({
        id:variant_id,
        quantity:qty
       })
     }

    $.ajax({
  url: '/cart/add.js',
  type: 'POST',
  data: { items: bundle_cart },
  dataType: 'json',
  success: (data) => {
    console.log("Success ===", data);
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: data }
    }));
    $(document).trigger('add:cart:success', { cart: data });
    $("form button.t4s-product-form__submit-jtpl[name='add']").eq(0).trigger('click')
    $(".main-btn .button-text").attr("style", "display: block");
    $(".main-btn .loading").attr("style", "display: none");

  },
  error: (err) => {
    console.log("Error ===", err);
  }
});


     console.log("Bundle====",bundle_cart);
}

   }); 

     $('input[name="globo-option-0"]').click(function(){
      console.log("Clickkk======");
      
      let selected_size=$("input[name='globo-option-0']:checked").val();
      if (selected_size) {
        $(".bundle-products-section select.hide").removeClass("hide")
      }

     });
     $(document).on('cart:updated', function(event) {
    console.log(" cart:updated event triggered!");
    console.log("Event detail:", event);
});
 $(document).on('add:cart:success', function(event) {
    console.log(" add:cart:success event triggered!");
    console.log("Event detail:", event);
});


/****** code if user changes sizes starts ******/
(function () {
  if (!window.location.search.includes("variant=")) return;
  const url = new URL(window.location.href);
  url.searchParams.delete("variant");
  const cleanURL = url.pathname + url.search;

  window.history.replaceState({}, "", cleanURL);
})();

setTimeout(function () {
$("input[name='globo-option-0']").prop("checked", false).removeAttr("checked");
$(".t4s-swatch__item, ul.value li.select-option").removeClass("is-selected active");
$("form select[name='id']").prop("selectedIndex", -1);
}, 800);

var swatches = setInterval(swatchLoad, 100);
function swatchLoad(){
$(".t4s-swatch__list .t4s-swatch__item, ul.value li.select-option.globo-sold-out-cross-out").click(function(){
  if($('.globo-swatch-list ul.value').length >0){
  // e.preventDefault();
  console.log("==Click item===");
  
  let selected_main_pdt=$("form select[name='id'] option:checked").val()
  let VariantAvailable=$(`select#product-variants-jtpl option[data-variant-id='${selected_main_pdt}']`).attr('data-available')
  
  let total_cards=$(".bundle-products-section .bundle-card.saree-shaper").length ;
  let selected_size=$("input[name='globo-option-0']:checked").val();
  console.log("total_cards====",total_cards);
  console.log("selected_size====",selected_size);
  if (selected_size) {
    let selected_main_pdt=$("form select[name='id'] option:checked").val()
    let MainProductAvailable=$(`select#product-variants-jtpl option[data-variant-id='${selected_main_pdt}']`).data('available');
    if (!MainProductAvailable) {
      $(".bundle-products-section .bundle-card").eq(0).prepend("<span class='sold-out'>Sold Out</span>")
    }
    else{
      $(".bundle-products-section .bundle-card").eq(0).find(".sold-out").remove()
    }
    //  CalculateTotal();
    $(".atc-bundle-section p.msg").hide()
    if (VariantAvailable=="true") {
     if (!$(".bundle-products-section .bundle-card .sold-out").length) {
       $(".bundle-products-section button.atc-btn").removeClass("disable")
     }
     else{
      $(".bundle-products-section button.atc-btn").addClass("disable")
     }
    }
   }
   else{
    return;
   }

   if (selected_size ) {
    $(".atc-bundle-section p.msg").hide()
    if (VariantAvailable=="false") {
      $(".bundle-products-section button.atc-btn").addClass("disable")
        $(`.bundle-products-section .bundle-card`).eq(0).find(".sold-out").remove()
        $(`.bundle-products-section .bundle-card`).eq(0).prepend("<span class='sold-out'>Sold Out</span>");
    }
   }

clearInterval(swatches);
  }
});
}

/****** code if user changes sizes ends ******/

/****** code if user changes regular-tall [HEIGHT] tabs starts ******/
  $('.is-t4s-name__pattern .t4s-swatch__item,.is-t4s-name__height .t4s-swatch__item').click(function(){
    let selected_size=$("input[name='globo-option-0']:checked").val();
    let pattern=$(this).attr("data-swatch");
    $(`.bundle-products-section .bundle-card.saree-shaper .size-selector select`).removeClass("active");
    $(`.bundle-products-section .bundle-card.saree-shaper .size-selector select#option-${pattern}`).addClass("active")
    if (selected_size) {
      setTimeout(() => {
 let selected_main_pdt=$("form select[name='id'] option:checked").val()
  let MainProductAvailable=$(`select#product-variants-jtpl option[data-variant-id='${selected_main_pdt}']`).attr('data-available')

      console.log("Selected pattern===",pattern);      
    let totalCards = $(".bundle-products-section .bundle-card.saree-shaper").length;
    let allAvaiable=true;

for (let i = 1; i < totalCards; i++) {
  let $card = $(".bundle-products-section .bundle-card.saree-shaper").eq(i);

  let $selectedOption = $card.find(`select#option-${pattern} option:selected`);
  let isAvailable = $selectedOption.data('available'); // retrieves data-available attr

  console.log("isAvailable====", isAvailable);
  console.log("pattern==", pattern);

  if (isAvailable === false || isAvailable === 'false') {
    // Remove any existing .sold-out element and prepend the new one
    $card.find(".sold-out").remove();
    $card.prepend("<span class='sold-out'>Sold Out</span>");
    allAvaiable=false;
  } else {
    // Remove .sold-out if it exists and item is available
    $card.find(".sold-out").remove();
  }
}

if (!allAvaiable || !MainProductAvailable || MainProductAvailable=="false") {
  $(".bundle-products-section button.atc-btn").addClass("disable")
}
else{
  $(".bundle-products-section button.atc-btn").removeClass("disable")
}
if (!MainProductAvailable || MainProductAvailable=="false") {
  $(".bundle-products-section .bundle-card.saree-shaper").eq(0).prepend("<span class='sold-out'>Sold Out</span>")
}
else{
   $(".bundle-products-section .bundle-card.saree-shaper").eq(0).find(".sold-out").remove();
}


   }, 500);
    }
    
  });
/****** code if user changes regular-tall [HEIGHT] tabs ends *****/

});

function CalculateTotal() {
  let totalval=0;
  let selected_main_pdt=$("form select[name='id'] option:checked").val()
  let VariantValue=$(`select#product-variants-jtpl option[data-variant-id='${selected_main_pdt}']`).attr('data-mprice')
  totalval=parseInt(VariantValue);
  console.log("Customm click=====",VariantValue);
  console.log("Total===",$(VariantValue).attr('data-mprice'));

   let total_bundles= $(".bundle-products-section .bundle-card").length
   let data_swatch=$(".globo-wrapper-jtpl .size-optionA .t4s-swatch__list [data-swatch-item].is--selected").attr("data-swatch");

     for (let i = 1; i < total_bundles; i++) {
      let price=$(".bundle-products-section .bundle-card").eq(i).find(`select#option-${data_swatch} option:checked`).attr("data-price");
      price=parseInt(price);
      if (!price) {
        price=$(".bundle-products-section .bundle-card").eq(i).find("select option:checked").attr("data-price")
        price=parseInt(price);
        if (!price) {
           price=$(".bundle-products-section .bundle-card").eq(i).attr("data-price");
           price=parseInt(price);
        }
        
      }
      if (price) {
        totalval+=price
      }
      
      console.log("Price===",price);
     }
     let formatMoney=T4SThemeSP.Currency.formatMoney(`${totalval}`);
     $('.bundle-products-section button.atc-btn .total').text(` : ${formatMoney} + FREE SHIPPING`)
  
}

function addSareeShaper() {
   let qty=$("input.t4s-quantity-input").val()
    let bundle_cart=[];
    let selected_size=$("input[name='globo-option-0']:checked").val();
     let option1=   $(".size-optionA .t4s-swatch__list .t4s-swatch__item.is--selected").text()

    let selected_main_pdt=$("form select[name='id'] option:checked").val()
    console.log("selected_size===",selected_size);
    console.log("option1===",option1);
     console.log("selected_main_pdt===",selected_main_pdt);
      if (selected_size && $("body").hasClass("saree-shaper")) {
        // $("form select[name='id'] option:checked").val("50469583946044")
      }

       let total_bundles= $(".bundle-products-section .bundle-card").length
           let data_swatch=$(".globo-wrapper-jtpl .size-optionA .t4s-swatch__list [data-swatch-item].is--selected").attr("data-swatch")

     for (let i = 1; i < total_bundles; i++) {
      let variant_id;
      if ($(".bundle-products-section .bundle-card").eq(i).hasClass("saree-shaper")) {
        variant_id=$(".bundle-products-section .bundle-card").eq(i).find(`select#option-${data_swatch}`).val()
      }
      else{
        variant_id=$(".bundle-products-section .bundle-card").eq(i).find(`select[name^='variants-']`).val()
      }
      console.log("Variant===",variant_id);
       bundle_cart.push({
        id:variant_id,
        quantity:qty
       })
     }

     $.ajax({
  url:'/cart/add.js',
  type:"POST",
  dataType:'json',
  data:{ items:bundle_cart},
    success: (data) => {
    console.log("Success ===", data);
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: data }
    }));
    $(document).trigger('add:cart:success', { cart: data });
    $("form button.t4s-product-form__submit-jtpl[name='add']").eq(0).trigger('click')
     $(".main-btn .button-text").attr("style", "display: block");
      $(".main-btn .loading").attr("style", "display: none");
  },
  error:(err)=>{
    console.log("Error==",err);
    
  }
});

     console.log("Saree bundle===",bundle_cart);
     
}

// T4SThemeSP.Currency.formatMoney('20000')